import constClass from '../../Constants/Constants';
import Common from '../Common/common';
import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

const RankUp = ({ siteId, mallId, shopCode, customerId, liffAccessToken, benefitClick, detailClick }) => {
  const [rankCustomerInfo, setRankCustomerInfo] = useState([]);

  //バックエンドサーバから会員に関する情報を取得
  const refreshData = useCallback(async () => {
    try {
      //各データ取得APIを先に実行
      const rank_customer_info_promise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/customerrank/line/rankupsearch/`, { site_id: siteId, customer_id: customerId, line_id: liffAccessToken, mall_id: mallId });
      //会員名を取得
      const rank_customer_data = (await rank_customer_info_promise).data;
      if (rank_customer_data && rank_customer_data[0].t_customer_rank[0].rankup_bonus_flag !== constClass.FLAG.ON) {
        if (rank_customer_data.length === 1) {
          detailClick(rank_customer_data[0].benefit_id);
        }
        setRankCustomerInfo(rank_customer_data);
      }

    } catch (err) {
      console.log(err);
    }
  }, [siteId, mallId, customerId, liffAccessToken, detailClick]);

  useEffect(() => {
    refreshData();
  }, [refreshData]);

  return (
    <div id="ticketList" className="ticket-list">
      <div className='rankupframe29 mb-2'>
        <div className="rankup_congrats my-2">ランクアップおめでとうございます!</div>
        <div className="select_benefit">以下特典から1点お選びいただけます。</div>
      </div>
      <div className="group29">
        {rankCustomerInfo && rankCustomerInfo.find(benefit => benefit.rank_id === 1) &&
          <div className="rankupiconframe29">
            <React.Fragment>
              <img src={`/${siteId}/bronzecrown.png`} alt={'冠'} />
              <div className="rankupicontext">ブロンズ</div>
            </React.Fragment>
          </div>
        }
        {rankCustomerInfo && rankCustomerInfo.find(benefit => benefit.rank_id === 2) &&
          <div className="rankupiconframe29">
            <React.Fragment>
              <img src={`/${siteId}/silvercrown.png`} alt={'冠'} />
              <div className="rankupicontext">シルバー</div>
            </React.Fragment>
          </div>
        }
        {rankCustomerInfo && rankCustomerInfo.find(benefit => benefit.rank_id === 3) &&
          <div className="rankupiconframe29">
            <React.Fragment>
              <img src={`/${siteId}/goldcrown.png`} alt={'冠'} />
              <div className="rankupicontext">ゴールド</div>
            </React.Fragment>
          </div>
        }
        {rankCustomerInfo && rankCustomerInfo.find(benefit => benefit.rank_id === 4) &&
          <div className="rankupiconframe29">
            <React.Fragment>
              <img src={`/${siteId}/platinumcrown.png`} alt={'冠'} />
              <div className="rankupicontext">プラチナ</div>
            </React.Fragment>
          </div>
        }
        {rankCustomerInfo && rankCustomerInfo.find(benefit => benefit.rank_id === 5) &&
          <div className="rankupiconframe29">
            <React.Fragment>
              <img src={`/${siteId}/vipcrown.png`} alt={'冠'} />
              <div className="rankupicontext">VIP</div>
            </React.Fragment>
          </div>
        }
        {rankCustomerInfo && rankCustomerInfo.map(benefit =>
          <React.Fragment key={benefit.benefit_id}>
            <div className="rankupbenefit">
              <div className='benefit-frame39'>
                <div className="benefit_title mt-3">{benefit.benefit_title}</div>
                {benefit.benefit_summary && <div className="benefit_summary pt-2">{benefit.benefit_summary}</div>}
              </div>
              <div className='benefit-frame42'>
                {benefit.benefit_image_url &&
                  <img className="benefit-image" src={`/${siteId}/${constClass.BENEFIT_IMAGE_DIR}${benefit.benefit_image_url}`} alt={benefit.benefit_title} style={{ objectFit: 'cover' }} />
                }
                {!benefit.benefit_image_url &&
                  <img className="benefit-image" src={`/${siteId}/noimage.png`} alt="noimage" style={{ objectFit: 'cover' }} />
                }
                <div className='frame41'>
                  <div className="ticket-detail">{Common.getBrString(benefit.benefit_detail)}</div>
                  <button
                    onClick={() => benefitClick(benefit.benefit_id)}
                    className="button text-black bg-lightwhite">
                    特典利用画面に移る
                  </button>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    </div>
  )
}

export default RankUp;